import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import { useRef, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './ComposerActionsButton.pcss'

interface AddToBucketButtonProps {
  disabled: boolean
  postsCount: number
  className?: string
  onSubmit: () => void
  onSubmitCreateNew?: () => void
}

export function AddToBucketButton(props: AddToBucketButtonProps) {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)

  const toggleMenu = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const closeMenu = (event: MouseEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }
    setOpen(false)
  }

  const onCreateNewClick = () => {
    props.onSubmitCreateNew?.()
    setOpen(false)
  }

  if (!props.onSubmitCreateNew) {
    return (
      <div className={`${styles.container} ${props.className || ''}`} data-testid="add-to-bucket-button">
        <Button
          variant="contained"
          color="primary"
          className={styles['btn-main']}
          disabled={props.disabled}
          onClick={props.onSubmit}
        >
          <FormattedMessage id="composer.actions.save-to-bucket" values={{ posts: props.postsCount }} />
        </Button>
      </div>
    )
  }

  return (
    <div className={`${styles.container} ${props.className || ''}`} data-testid="add-to-bucket-button">
      <ButtonGroup
        disabled={props.disabled}
        variant="contained"
        color="primary"
        ref={anchorRef}
        disableRipple
        className={styles['btn-group']}
      >
        <Button className={styles['btn-main']} onClick={props.onSubmit}>
          <FormattedMessage id="composer.actions.save-to-bucket" values={{ posts: props.postsCount }} />
        </Button>
        <Button
          color="primary"
          size="small"
          disableElevation
          data-testid="add-to-bucket-menu-toggle"
          onClick={toggleMenu}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} disablePortal className={styles.popper}>
        <Paper data-testid="add-to-bucket-menu">
          <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={closeMenu}>
            <MenuList>
              <MenuItem onClick={onCreateNewClick} className={styles['menu-item']}>
                <FormattedMessage id="composer.actions.save-to-bucket-create-new" />
              </MenuItem>
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popper>
    </div>
  )
}

export default AddToBucketButton
